// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { CreateOrganizationAttributesDTO } from './create-organization-attributes-dto';

/**
 * 
 * @export
 * @interface CreateOrganizationDTO
 */
export interface CreateOrganizationDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationDTO
     */
    parentId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationDTO
     */
    parentOrganizationGroupId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationDTO
     */
    organizationGroupId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationDTO
     */
    integratorId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationDTO
     */
    internalSalesOwnerId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationDTO
     */
    name: string;
    /**
     * 
     * @type {CreateOrganizationAttributesDTO}
     * @memberof CreateOrganizationDTO
     */
    attributes?: CreateOrganizationAttributesDTO;
    /**
     * 
     * @type {object}
     * @memberof CreateOrganizationDTO
     */
    settings?: object;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationDTO
     */
    type: CreateOrganizationDTOTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationDTO
     */
    primaryVertical: CreateOrganizationDTOPrimaryVerticalEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateOrganizationDTO
     */
    secondaryVerticals: Array<CreateOrganizationDTOSecondaryVerticalsEnum>;
}

/**
    * @export
    * @enum {string}
    */
export enum CreateOrganizationDTOTypeEnum {
    AGENCY = 'AGENCY',
    BUILDTORENT = 'BUILD_TO_RENT',
    PRIVATE = 'PRIVATE',
    INTEGRATORREFERRAL = 'INTEGRATOR_REFERRAL'
}
/**
    * @export
    * @enum {string}
    */
export enum CreateOrganizationDTOPrimaryVerticalEnum {
    INDEPENDENTSINGLE = 'INDEPENDENT_SINGLE',
    BTR = 'BTR',
    INDEPENDENTMULTI = 'INDEPENDENT_MULTI',
    FRANCHISE = 'FRANCHISE',
    CORPORATE = 'CORPORATE',
    PRIVATELANDLORD = 'PRIVATE_LANDLORD',
    STUDENT = 'STUDENT',
    HMO = 'HMO',
    PBSA = 'PBSA'
}
/**
    * @export
    * @enum {string}
    */
export enum CreateOrganizationDTOSecondaryVerticalsEnum {
    INDEPENDENTSINGLE = 'INDEPENDENT_SINGLE',
    BTR = 'BTR',
    INDEPENDENTMULTI = 'INDEPENDENT_MULTI',
    FRANCHISE = 'FRANCHISE',
    CORPORATE = 'CORPORATE',
    PRIVATELANDLORD = 'PRIVATE_LANDLORD',
    STUDENT = 'STUDENT',
    HMO = 'HMO',
    PBSA = 'PBSA'
}



